module.exports = __webpack_public_path__ + "static/img/5.9ce9f2c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/sp/5.png
// module id = DA8u
// module chunks = 0